export const AUTH_TOKEN = "auth_token";
export const LOGIN_INFO = "login_info";
export const LOGIN_EMAIL = "login_email";
